import * as React from 'react';

import { useAccountLocation } from '@/lib/navigation';
import { UISelect } from '../ui-elements/UISelect';
import { Modal } from '../shared/Modal';
import { AuthenticityTokenInput } from '../shared/AuthenticityTokenInput';

const OutboundMessageFormContent =
  ({ inputRef }: { inputRef: React.RefObject<HTMLInputElement> }) => (
    <form action={useAccountLocation('tickets/load_or_create')} method="post">
      <AuthenticityTokenInput />
      <h4>
        Enter your contact&apos;s
        <b> phone number</b>
      </h4>

      <div className="contact-input">
        <div className="ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset ui-focus">
          <input
            ref={inputRef}
            type="text"
            name="load_or_create_phone"
            id="contact-detail"
            className="input-xlarge"
            placeholder="phone or name"
            autoComplete="off"
            data-role="none"
          />
        </div>
        <div className="show-on-options">
          <div className="title">
            <div>
              {'Navigate with '}
              <span className="key">tab</span>
              {' or '}
              <span className="key">&uarr;&darr;</span>
            </div>
            <div>
              {'Choose with '}
              <span className="key">enter</span>
            </div>
          </div>
        </div>
      </div>

      <div id="create-contact-footer" className="desc hide">
        <div className="ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset">
          <input
            type="text"
            name="load_or_create_name"
            id="contact-detail-name"
            className="input-xlarge"
            placeholder="name (optional)"
            autoComplete="off"
            data-role="none"
          />
        </div>
        <UISelect prompt="Any Channel" name="load_or_create_channel">
          <option value="" selected>Any Channel</option>
          <option value="sms">SMS</option>
          <option value="live_chat">Live Chat</option>
          <option value="whatsapp">WhatsApp</option>
        </UISelect>
        <input
          type="submit"
          name="commit"
          value="Start a Conversation"
          id="create-contact"
          className="button-submit"
          data-role="none"
        />
      </div>
    </form>
  );

export class OutboundMessageForm extends React.PureComponent {
  modalRef = React.createRef<Modal>();

  inputRef = React.createRef<HTMLInputElement>();

  componentDidMount() {
    window.setupOutboundMessageModal();
  }

  componentDidUpdate() {
    window.setupOutboundMessageModal();
  }

  show() {
    this.modalRef.current.setActive(true, () => this.inputRef.current.focus());
  }

  hide() {
    this.modalRef.current.setActive(false);
  }

  render() {
    return (
      <Modal ref={this.modalRef} dismissable showDarkOverlay>
        <div className="ui-popup-container ui-popup-active" id="outbound-modal-popup">
          <div className="ui-content ui-popup ui-body-inherit ui-overlay-shadow ui-corner-all" id="outbound-modal" data-role="popup">
            <OutboundMessageFormContent inputRef={this.inputRef} />
          </div>
        </div>
      </Modal>
    );
  }
}
